// databaseNode.js

import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const DatabaseNode = ({ id, data }) => {
    const [dbType, setDbType] = useState(data?.dbType || 'PostgreSQL');
    const [query, setQuery] = useState(data?.query || 'SELECT * FROM users;');

    return (
        <BaseNode
            id={id}
            title="Database Node"
            handles={[
                { type: 'target', position: Position.Left, id: `${id}-trigger` },
                { type: 'source', position: Position.Right, id: `${id}-data` }
            ]}
        >
            <label style={{ display: 'flex', flexDirection: 'column', fontSize: '12px' }}>
                Database Type:
                <select value={dbType} onChange={(e) => setDbType(e.target.value)} style={{ marginTop: '4px' }}>
                    <option value="PostgreSQL">PostgreSQL</option>
                    <option value="MySQL">MySQL</option>
                    <option value="MongoDB">MongoDB</option>
                </select>
            </label>
            <label style={{ display: 'flex', flexDirection: 'column', fontSize: '12px', marginTop: '4px' }}>
                Query:
                <textarea
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    style={{ marginTop: '4px', resize: 'vertical', minHeight: '40px' }}
                />
            </label>
        </BaseNode>
    );
}
